import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import { selectFilters, selectLocation } from '../menu/filtersSlice'
import { selectLocationStatus, selectPlaces } from './locationSlice'
import { ReactComponent as NewPlace } from 'assets/newPlace.svg'
import { ReactComponent as Location } from 'assets/location.svg'
import { ReactComponent as Arrow } from 'assets/arrowDown.svg'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import AutomationPopup from '../Popups/AutomationPopup'
import PlaceElementForList from './PlaceElementForList'
import { useState, Fragment, useEffect } from 'react'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import SkeletonElement from './SkeletonElement'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isMobile } from 'utils/isMobile'
import SortSelect from './SortSelect'
import Error from 'components/Error'

const mobile = isMobile()

const ResultList = () => {
  const { attributes: { warehouseTypeId } = {} } = useSelector(selectFilters)
  const status = useSelector(selectLocationStatus)
  const location = useSelector(selectLocation)
  const places = useSelector(selectPlaces)

  const [list, showList] = useState(false)
  const { popup } = usePopupState()

  const { push } = useHistory()
  const { t } = useTranslation('map')

  useEffect(() => {
    let timeout = setTimeout(() => showList(true), 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  const getList = () => Object.entries(places).map(([k, v]) => {
    const title = k === 'filtered' && v.length > 0 ? (
      <div className='list__header'>
        <span>{t('seeOtherLocations')}</span>
        <Arrow />
      </div>
    ) : k === 'localized' && v.length > 0 ? (
      <div className='list__header'>
        <span>{t('seeOtherOptions')}</span>
        <Arrow />
      </div>
    ) : false

    const elements = v.map((e, idx) => <PlaceElementForList
      data={e}
      key={idx}
      idx={idx}
      warehouseTypeId={warehouseTypeId} />)

    return <Fragment key={k}>
      {title}
      {v.length > 0 && <div className='resultList'>
        {elements}
      </div>}
    </Fragment>
  })

  return (
    <>
      {popup?.type === 'warehouse_attr' && popup?.place_attrs && <WarehouseAttrPopup body={popup?.place_attrs} />}
      {popup?.type === 'automation' && popup?.automation && <AutomationPopup body={popup?.automation} />}
      {status === STATUS.idle ? <div
        className='result__start'>
        {!location && <div className='start__tile center'>
          <p>{t('resultsWillAppearAfterEnteringYourLocation')}</p>
          <button
            className='button --arrow --enlarged'
            onClick={() => push('/mapsearch')}>
            <Location />
            <span className='--secFont'>{t('addAddress')}</span>
          </button>
        </div>}

        <div
          className='start__tile center'
          onClick={() => push(window.location.pathname, LOCATION_STATES.popup('newplace'))}>
          <p>{t('magCloserToYou')}</p>
          <button className='button --arrow --enlarged --black'>
            <NewPlace />
            <span className='--secFont'>{t('reportANewLocation')}</span>
          </button>
        </div>
      </div> : <div className='result__main'>
        <div className='result__group group'>
          <div className='result__title'>{t('foundItems')}</div>
          <SortSelect />
        </div>

        {status === STATUS.failed ? <Error text={t('noResults')} />
          : status === STATUS.succeed && list ? <div>{getList()}</div>
            : <div className='list'>
              {(mobile ? [1, 2] : [1, 2, 3]).map(e => <SkeletonElement key={e} />)}
            </div>}
      </div>}
    </>)
}

export default ResultList